import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import {PopoverComponent} from "./popover.component";

@NgModule({
    imports: [CommonModule, TranslateModule],
    exports: [PopoverComponent],
    declarations: [PopoverComponent]
})
export class CustomPopoverModule {}
